import { getAppUrl } from "@helsenorge/framework-utils/url";
import { HNeventShowAppInvitation } from "@helsenorge/framework-utils/web-component/events";

const tjenestePath: string = "?tjeneste=oppgaver";
const loginUrl: string = `/auth/signin?Source=${encodeURIComponent(`${window.location.origin}/oppgaver`)}`;

export const useLogin = (): {
  login: (
    ref?: React.MutableRefObject<HTMLButtonElement | HTMLAnchorElement | null>,
  ) => void;
} => {
  const appUrl = getAppUrl();
  const handleLogin = (): void => {
    window.history.replaceState(window.history.state, "", loginUrl);
    window.location.reload();
  };

  const login = (
    ref?: React.MutableRefObject<HTMLButtonElement | HTMLAnchorElement | null>,
  ): void => {
    if (appUrl) {
      HNeventShowAppInvitation(
        () => {
          const fullAppUrl = appUrl + tjenestePath;
          window.location.href = fullAppUrl;
        },
        () => {
          handleLogin();
        },
        () => {
          ref?.current?.focus();
        },
      );
    } else {
      handleLogin();
    }
  };
  return { login };
};
